const STORAGE_KEY = 'hlm-santral-wizard-snapshot';

export function saveSantralWizardSnapshot(snapshot) {
  if (!snapshot?.isSantralFlow) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...snapshot, savedAt: Date.now() }));
  } catch {
    /* ignore quota / private mode */
  }
}

export function loadSantralWizardSnapshot() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.isSantralFlow ? parsed : null;
  } catch {
    return null;
  }
}

export function clearSantralWizardSnapshot() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
